import React, {Component} from 'react';
import AcrWorkflowRow from './AcrWorkflowRow';
import {PropTypes} from "prop-types";
import "./ConfigurableWorkflow.scss";
import * as messageConstants from "../../../shared/messages";

class ConfigurableWorkflow extends Component {

    static propTypes = {
        oidcAcrWorkflows: PropTypes.array,
        workflows: PropTypes.array,
        addConfigurableWorkflow: PropTypes.func,
        predefinedAcrWorkflow: PropTypes.array,
        defaultAcrWorkflows: PropTypes.array,
        updateConfigurableWorkflow: PropTypes.func,
        deleteConfigurableWorkflow: PropTypes.func,
        displayConfigurableWorkflow: PropTypes.bool,
    }


    handleAddRow = () => {
        const newRow = {
            acrValue: '',
            workflow: this.props.workflows[0] || null,
            isDefault: false
        };
        if (this.props.addConfigurableWorkflow) {
            this.props.addConfigurableWorkflow(newRow);
        }
    };

    handleRowChange = (id, updatedRowObject) => {
        if (this.props.updateConfigurableWorkflow) {
            this.props.updateConfigurableWorkflow(id, updatedRowObject);
        }
    }

    handleRemove = (id) => {
        if (this.props.deleteConfigurableWorkflow) {
            this.props.deleteConfigurableWorkflow(id);
        }
    }

    componentDidUpdate(prevProps) {
        //for new OIDC app creation
        if (
            (!this.props.oidcAcrWorkflows ||
                !Array.isArray(this.props.oidcAcrWorkflows) ||
                this.props.oidcAcrWorkflows.length === 0)
            && this.props.defaultAcrWorkflows.length > 0
        ) {
            this.props.defaultAcrWorkflows.forEach(workflow => {
                this.props.addConfigurableWorkflow(workflow);
            });
        }
    }



    render() {
        const configurableWorkflowRows = this.props.oidcAcrWorkflows ? this.props.oidcAcrWorkflows.map(
            (row, index) =>
                <AcrWorkflowRow
                    id={index}
                    key={index}
                    rowObject={row}
                    workflows={this.props.workflows}
                    predefinedAcrWorkflow={this.props.predefinedAcrWorkflow}
                    onChange={this.handleRowChange}
                    onRemove={this.handleRemove}
                />
        ): [];
        return ( this.props.displayConfigurableWorkflow ?
            <div>
                <h3 className='sba-subtitle'>{messageConstants.ACR_MAPPING_TITLE}</h3>
                <div className="add-edit-subtitle">
                    {messageConstants.ACR_MAPPING_SUBTITLE}
                </div>
                <div className="configurable-workflow-table">
                <table>
                    <tbody>
                    {configurableWorkflowRows.length > 0 ? (
                        <tr>
                            <th className="acr-title">{messageConstants.ACR_VALUE_COLUMN}</th>
                            <th className="workflow-dropdown-title pl-12">{messageConstants.WORKFLOW_COLUMN}</th>
                            <th className="td-blank" />
                            <th className="action-title">{messageConstants.ACTIONS_COLUMN}</th>
                        </tr>
                    ): null}
                    {configurableWorkflowRows}
                    <tr>
                        <td className="add-attribute">
                            <button type="button" onClick={this.handleAddRow} className="attr-button">
                                <span className="fa fa-plus btn-circle btn-plus"/>
                                <span className="attr-button-label">
                                    {messageConstants.ADD_BUTTON}
                                </span>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
            </div>
            </div> : null
        );
    }
}

export default ConfigurableWorkflow;
